import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import EmailTemplateStatus from '@/models/EmailTemplates/EmailTemplateStatus';
import EmailTemplateType from '@/models/EmailTemplates/EmailTemplateType';
import IntegrationDto from '@/models/Integrations/IntegrationDto';

export default class EmailTemplateDto extends BaseAgencyScopeEntityDto {
    name = '';
    status: EmailTemplateStatus = EmailTemplateStatus.Active;
	type: EmailTemplateType;
	integrationSystemId = '';
	templateId = '';
}
